//import Vue from 'vue'
import Router from 'vue-router'

//import App from '../App.vue'

//Vue.use(Router)



const router = new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: require('../components/Home.vue').default
        },
        {
            path: '/json/:id',
            name: 'Json',
            component: require('../components/Json.vue').default
        },
    ]
})

export default router